import React from 'react'

import {useProductList} from '../util/product-list-context'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'

import PageHeader from './page-header'
import ProductListTopPanel from './product-list-top-panel'
import RefinementsDrawer from './refinements-drawer'
import ProductListClassicSubset from './product-list-classic-subset'

// Utils
import BottomElements from './bottom-elements'

/**
 * A React functional component that renders a classic product list page layout.
 *
 * @returns {JSX.Element} A JSX element representing the product list page layout.
 */
const ProductListClassic = () => {
    const {category, productSearchResult} = useProductList()

    return (
        <>
            {/* Header */}
            <PageHeader />

            <Box as="section">
                {/* Top PLP panel */}
                <ProductListTopPanel />

                <ProductListClassicSubset subSet={productSearchResult?.hits} />

                {/* PLP Bottom  */}
                <BottomElements category={category} />

                {/* Drawer for filter options */}
                <RefinementsDrawer />
            </Box>
        </>
    )
}

ProductListClassic.propTypes = {}

export default ProductListClassic
